/**
 * Quick status check - just get the course and show status
 */

import { getCourseById } from '../services/courseService';
import { get } from '@aws-amplify/api-rest';
import { fetchAuthSession } from 'aws-amplify/auth';

export async function quickStatusCheck() {
  const COURSE_ID = '045ef510-0d3d-41f7-808e-e75a77cb765c';
  
  console.log('🔍 QUICK STATUS CHECK');
  console.log('=' .repeat(50));
  
  try {
    // Method 1: Using courseService
    console.log('\nMethod 1: Using courseService.getCourseById()...');
    const course = await getCourseById(COURSE_ID);
    console.log('Course title:', course.title);
    console.log('Course status:', course.status);
    console.log('Status as JSON:', JSON.stringify(course.status));
    console.log('Status === "published"?', course.status === 'published');
    console.log('Status === "Published"?', course.status === 'Published');
    
    // Show all course fields
    console.log('\nAll course fields:');
    Object.keys(course).forEach(key => {
      if (key === 'status' || key.includes('tatus')) {
        console.log(`  ${key}:`, course[key], `(JSON: ${JSON.stringify(course[key])})`);
      }
    });
    
    // Method 2: Direct API call
    console.log('\nMethod 2: Direct API call...');
    const session = await fetchAuthSession();
    const directResponse = await get({
      apiName: 'CourseBookingApi',
      path: `courses/${COURSE_ID}`,
      options: {
        headers: {
          Authorization: `Bearer ${session.tokens.idToken.toString()}`
        }
      }
    });
    
    // Parse response
    let directCourse = directResponse;
    if (directResponse.response) {
      directCourse = await directResponse.response;
    }
    if (typeof directCourse.json === 'function') {
      directCourse = await directCourse.json();
    }
    if (typeof directCourse.body === 'string') {
      directCourse = JSON.parse(directCourse.body);
    }
    
    console.log('Direct API status:', directCourse.status);
    console.log('Direct API status JSON:', JSON.stringify(directCourse.status));
    
    // Check if there's a difference
    if (course.status !== directCourse.status) {
      console.log('⚠️ MISMATCH! Service returns different status than direct API!');
    }
    
    return course;
    
  } catch (error) {
    console.error('Status check failed:', error);
  }
}

window.quickStatusCheck = quickStatusCheck;